import type { StatusVariant } from './StatusBadge';

/**
 * Maps common lead statuses to StatusBadge variants
 */
export function getLeadStatusVariant(status: string): StatusVariant {
  switch (status) {
    case 'Sold':
      return 'active';
    case 'Unassigned':
      return 'inactive';
    case 'Assigned':
      return 'info';
    case 'NoGo':
    case 'Dead':
      return 'error';
    case 'Closed':
      return 'purple';
    default:
      return 'inactive';
  }
}

/**
 * Maps common job statuses to StatusBadge variants
 */
export function getJobStatusVariant(status: string): StatusVariant {
  switch (status) {
    case 'Sold':
      return 'active';
    case 'Closed':
    case 'Completed':
      return 'purple';
    case 'NoGo':
    case 'Cancelled':
      return 'error';
    default:
      return 'inactive';
  }
}
